const TEST_API_URL = 'https://test.stytch.com';
const LIVE_API_URL = 'https://api.stytch.com';
const CLIENTSIDE_SERVICES_IFRAME_URL = 'https://js.stytch.com/clientside-services/index.html';
const STYTCH_DFP_BACKEND_URL = `https://telemetry.stytch.com`;
const STYTCH_DFP_CDN_URL = `https://elements.stytch.com`;
const GOOGLE_ONE_TAP_HOST = 'https://accounts.google.com/gsi';
const GOOGLE_ONE_TAP_SCRIPT_URL = `${GOOGLE_ONE_TAP_HOST}/client`;
const DEFAULT_SESSION_DURATION_MINUTES = 30;
const DEFAULT_OTP_EXPIRATION_MINUTES = 5;
const MULTIPLE_STYTCH_CLIENTS_DETECTED_WARNING = "It looks like you're creating multiple copies of the Stytch client." + ' This behavior is unsupported, and unintended side effects may occur. ' + "Make sure you are creating the Stytch client at the global level, and not inside a component's render function.";

export { CLIENTSIDE_SERVICES_IFRAME_URL, DEFAULT_OTP_EXPIRATION_MINUTES, DEFAULT_SESSION_DURATION_MINUTES, GOOGLE_ONE_TAP_HOST, GOOGLE_ONE_TAP_SCRIPT_URL, LIVE_API_URL, MULTIPLE_STYTCH_CLIENTS_DETECTED_WARNING, STYTCH_DFP_BACKEND_URL, STYTCH_DFP_CDN_URL, TEST_API_URL };
//# sourceMappingURL=constants.mjs.map
